import {
  AdvertiserAccount,
  Workspace,
} from '@synapex/shared2/gateway-rest-api';
import { SnakeIdObj } from '@synapex/tools/typescript';

import { api, pickDto } from '@/shared/api';
import * as ReplyParser from './reply-parser';
import { WorkspaceDescriptor } from '@synapex/shared2/entities';

//query

export const users = ({
  advertiser_account_id,
}: SnakeIdObj<'advertiser_account'>) =>
  api
    .get<AdvertiserAccount.User.UsersReply>(
      `advertiser-account/${advertiser_account_id}/users`,
    )
    .then(({ users, ownerSettings }) => ({
      ownerSettings,
      users: users.map(ReplyParser.user),
    }));

export const workspaceUsers = ({
  workspace_type,
  workspace_id,
}: WorkspaceDescriptor) =>
  api
    .get<Workspace.UsersReply>(
      `workspace-2/${workspace_type}/${workspace_id}/users`,
    )
    .then(({ users, ownerSettings }) => ({
      ownerSettings,
      users: users.map(ReplyParser.user),
    }));

//mutations

export const updateUser =
  ({
    advertiser_account_id,
    user_id,
  }: SnakeIdObj<'advertiser_account' | 'user'>) =>
  (dto: AdvertiserAccount.User.UpdatePermissionInputDto) =>
    api
      .put<AdvertiserAccount.User.UserReply>(
        `advertiser-account/${advertiser_account_id}/users/${user_id}`,
        pickDto(AdvertiserAccount.User.UpdatePermissionInputDto, dto),
      )
      .then(ReplyParser.user);

export const updateWorkspaceUser =
  ({
    user_id,
    workspace_type,
    workspace_id,
  }: SnakeIdObj<'user'> & WorkspaceDescriptor) =>
  (dto: AdvertiserAccount.User.UpdatePermissionInputDto) =>
    api
      .put<Workspace.UserReply>(
        `workspace-2/${workspace_type}/${workspace_id}/users/${user_id}`,
        pickDto(AdvertiserAccount.User.UpdatePermissionInputDto, dto),
      )
      .then(ReplyParser.user);

export const deleteUser =
  ({
    advertiser_account_id,
    user_id,
  }: SnakeIdObj<'advertiser_account' | 'user'>) =>
  async () => {
    await api.delete(
      `advertiser-account/${advertiser_account_id}/users/${user_id}`,
    );
  };

export const deleteWorkspaceUser =
  ({
    user_id,
    workspace_type,
    workspace_id,
  }: SnakeIdObj<'user'> & WorkspaceDescriptor) =>
  async () => {
    await api.delete(
      `workspace-2/${workspace_type}/${workspace_id}/users/${user_id}`,
    );
  };

export const updateOwnerSettings =
  ({ advertiser_account_id }: SnakeIdObj<'advertiser_account'>) =>
  (dto: AdvertiserAccount.OwnerSettings.UpdateInputDto) =>
    api.put<AdvertiserAccount.OwnerSettings.Reply>(
      `/advertiser-account/${advertiser_account_id}/owner-settings`,
      pickDto(AdvertiserAccount.OwnerSettings.UpdateInputDto, dto),
    );

export const updateWorkspaceOwnerSettings =
  ({ workspace_type, workspace_id }: WorkspaceDescriptor) =>
  (dto: AdvertiserAccount.OwnerSettings.UpdateInputDto) =>
    api.put<AdvertiserAccount.OwnerSettings.Reply>(
      `/workspace-2/${workspace_type}/${workspace_id}/owner-settings`,
      pickDto(AdvertiserAccount.OwnerSettings.UpdateInputDto, dto),
    );
